import Vue from 'vue'

const requireComponent = require.context(
  '@/components/',
  true,
  /.vue/
)

function camelCase(str) {
  return str.split(/-|_/).map((s, i) => {
    s = s[0].toUpperCase() + s.slice(1)
    return s
  }).join('')
}

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  //   const componentName = fileName.replace(/(\.\/|\.vue)/g, '').replace(new RegExp('/', 'g'), '')
  const names = fileName.split('/')
  let componentName = camelCase(names.pop().replace(/\.\w+$/, ''))
  if (componentName === 'Index') {
    componentName = camelCase(names.pop().replace(/\.\w+$/, ''))
  }
  // 全局注册组件
  Vue.component(
    componentName,
    // 如果这个组件选项是通过 `export default` 导出的，
    // 那么就会优先使用 `.default`，否则回退到使用模块的根。
    componentConfig.default || componentConfig
  )
  // console.log('全局注册组件', componentName, fileName)
})
